import { render, staticRenderFns } from "./routeLayout.vue?vue&type=template&id=55f64980"
import script from "./routeLayout.vue?vue&type=script&lang=js"
export * from "./routeLayout.vue?vue&type=script&lang=js"
import style0 from "./routeLayout.vue?vue&type=style&index=0&id=55f64980&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f64980')) {
      api.createRecord('55f64980', component.options)
    } else {
      api.reload('55f64980', component.options)
    }
    module.hot.accept("./routeLayout.vue?vue&type=template&id=55f64980", function () {
      api.rerender('55f64980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Wrappers/routeLayout.vue"
export default component.exports